import { useLanguage } from '../../i18n/LanguageProvider';
import { WizardButton } from '../../ui';
import type { RegistrationRole } from '../registration/model';
import { startYandexOAuth, type YandexOAuthFlow } from './yandex';
import { startVkOAuth } from './vk';
import { startOidc } from './oidc';

export function SocialAuthButtons({ role, flow, compact = false }: {
  role: RegistrationRole;
  flow: YandexOAuthFlow;
  compact?: boolean;
}) {
  const { language } = useLanguage();
  const providers = language === 'en' ? ['Google', 'Apple'] : ['Яндекс', 'VK'];

  function start(provider: string) {
    if (provider === 'Яндекс') startYandexOAuth(role, flow);
    else if (provider === 'VK') startVkOAuth(role, flow);
    else startOidc(provider === 'Apple' ? 'apple' : 'google', role, flow);
  }

  return (
    <>
      <div className={compact ? 'request-wizard__social-row' : 'standalone-auth__social-row'} data-social-auth>
        {providers.map(provider => compact ? (
          <button key={provider} type="button" onClick={() => start(provider)}>{provider}</button>
        ) : (
          <WizardButton key={provider} kind="secondary" type="button" onClick={() => start(provider)}>{provider}</WizardButton>
        ))}
      </div>
    </>
  );
}
